import React from 'react';

import type { Color } from '@atlaskit/status/element';
import { Status } from '@atlaskit/status/element';

export const StatusComponent = ({ text, color }: { text: string; color: Color }) => (
	<span data-testid="status-component">
		<Status text={text} color={color} />
	</span>
);
